import React from 'react';
import { CtaButton } from './CtaButton';
import { Logo } from './Logo';
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-ink-950 py-20" aria-labelledby="ultima-llamada" data-id="element-38" data-mp="vg7rg1sze6jb">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-50" aria-hidden="true" data-id="element-39" data-mp="19gifyy6tj91b" />
      <div className="relative mx-auto flex max-w-2xl flex-col items-center px-5 text-center" data-id="element-40" data-mp="15bspxpyucoob">
        <Logo size="sm" data-id="element-41" data-mp="1jbk8m40ayt8n" />
        <h2 id="ultima-llamada" className="mt-8 font-display text-3xl uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-42" data-mp="1jasaomj8gjf7">
          Dos días de ejecución o dos años más{' '}
          <span className="text-brand-red" data-id="element-43" data-mp="1t4r8xag6rj1v">preguntándote cómo empezar</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-white/60" data-id="element-44" data-mp="1o5y5ybyizafy">
          Todo el sistema, los 6 activos y los 3 bonos por un pago único de $27, con garantía de
          devolución total.
        </p>
        <CtaButton className="mt-8 max-w-xl" subLabel="Acceso inmediato · Sin suscripción" data-id="element-45" data-mp="1x2ozaglp0b6u" />
      </div>
    </section>;
}